import { Component, OnInit} from '@angular/core';


@Component({
    selector: 'app-sign-up',
    templateUrl: './sign-up.component.html',
    standalone: false
})
export class SignUpComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
